import { DOCUMENT_CONTENT_TYPE } from "./documentContentType";
export default {
    [DOCUMENT_CONTENT_TYPE.TEXT]: "Текст",
    [DOCUMENT_CONTENT_TYPE.IMAGE]: "Изображение",
    [DOCUMENT_CONTENT_TYPE.AUDIO]: "Аудио",
    [DOCUMENT_CONTENT_TYPE.VIDEO]: "Видео"
};
